import { routes } from '~/components/app/appMainRoutes';

export const NEW_TARGET_MARKET_LIST = `${routes.targetMarkets}?new=true`;
